import routes from "./router/routes"
import medicationEventBus from "./events/event-bus"

export function medicationModule({ router, eventBus }) {
  for (const route of routes) router.addRoute("dashboard", route)

  medicationEventBus.init(eventBus)
}
